//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  getFeedbackRouteYsz,
  getFeedbackRouteWx,
  saveFormula,
  deleteFormulaList,
} from "../../../server/oldformula/index";
import Encode from "../../../server/api/encode";
import sa from "sa-sdk-javascript";
import { mapGetters, mapState } from "vuex";
import store from "../../../store";
export default {
  props: {
    title: {
      type: String,
    },
  },

  data() {
    return {
      routerURL: null,
      status: undefined,
      feedbackId: undefined,
      guid: "",
      uid: "",
      session: "",
      wechatCollectStatus: 0,
      isYsz: "loading",
      loading: false,
      from:""
    };
  },
  created() {
    this.from = this.$route.query.from;
    (this.guid = this.$route.query.guid ? this.$route.query.guid : ""),
      (this.uid = this.$route.query.uid ? this.$route.query.uid : ""),
      (this.session = this.$route.query.session
        ? this.$route.query.session
        : "");
    this.wechatCollectStatus = this.$route.query.wechatCollectStatus ? 1 : 0;
    const ua = navigator.userAgent.toLowerCase();
    this.isYsz = ua.indexOf("ysz") > -1;
    console.log(this.isYsz!='loading',111)
    this.appInterEventInit();
    setTimeout(() => {
      this.getFeedbackRoute();
    }, 500);
  },
  methods: {
    async wechatCollect() {
      try {
        if (!this.$route.query.uid||this.$route.query.uid=='0') {
          this.$toast("请登录后再试");
          return;
        }
        if (this.loading) {
          return
        }
        this.loading = true;  
        if (this.wechatCollectStatus == 0) {
          const res = await saveFormula({
            uid: this.uid,
            formulaId: this.$route.query.formulaId,
          });
          this.$toast("已加入常用");
          this.wechatCollectStatus = 1;
        } else {
          const res = await deleteFormulaList({
            uid: this.uid,
            formulaIds: [this.$route.query.formulaId],
          });
          this.$toast("已移除常用");
          console.log(res, '加入结果')
          this.wechatCollectStatus = 0;
        }
        this.loading = false;  
      } catch (error) {
        this.loading = false;
        this.$toast(error)
        console.log(error);
      }
    },
    // 获取跳转路由
    async getFeedbackRoute() {
      let self = this;

      let urlData = self.$route.query;
      const params = {
        formulaId: urlData.formulaId,
      };
      let isYsz = navigator.userAgent.indexOf("ysz") > -1;
      if (isYsz) {
        let res = await getFeedbackRouteYsz(params);
        console.log(res, decodeURIComponent(res.routerUrl), 661);
        if (res.code == 999) {
          let a = Encode.encodeFunc("login_main");
          let obj = {
            url: "https://tool.yxj.org.cn/app/" + a.data,
          };
          goPage(obj, (token) => {
            sa.registerPage({
              tool_isAnonymousVisitor: false,
            });
            localStorage.setItem("token", token);
            store.commit("editLoginStatus");
          });
        } else {
          this.routerURL = res ? res.routerUrl : "";
          this.status = res ? res.status : "";
          this.feedbackId = res ? res.feedbackId : "";
        }
      } else {
        console.log(self.guid, self.uid, self.session, "这里是微信！");
        params.guid = self.guid;
        params.uid = self.uid;
        params.session = self.session;
        try {
          let res = await getFeedbackRouteWx(params);
          console.log(res, 661);
          self.routerURL = res ? decodeURIComponent(res.routerUrl) : "";
          self.status = res ? res.status : "";
          self.feedbackId = res ? res.feedbackId : "";
        } catch (error) {
          console.log(error, 33);
        }
      }
    },
    linkTo() {
      let self = this;
      let urlData = self.$route.query;
      const ua = navigator.userAgent.toLowerCase();
      var isYsz = ua.indexOf("ysz") > -1;
      console.log(this.title);
      if (isYsz) {
        // 跳转医生站app
        jumpWithRoute(this.routerURL);
      } else {
        //
        if (this.status === 0) {
          // 跳转到反馈详情页面
          wx.miniProgram.navigateTo({
            url:
              "/packageA/pages/formula/feedback/details/index?feedbackId=" +
              this.feedbackId,
          });
        } else {
          // 跳转到反馈
          wx.miniProgram.navigateTo({
            url:
              "/packageA/pages/formula/feedback/submit/index?formulaId=" +
              urlData.formulaId +
              "&formulaName=" +
              this.title,
          });
        }
      }
    },
    // app交互事件初始化
    appInterEventInit() {
      var u = navigator.userAgent.toLowerCase();
      var isAndroid = u.indexOf("android") > -1 || u.indexOf("linux") > -1; //android终端
      var isiOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      let isYsz = u.indexOf("ysz") > -1;
      if (isiOS && isYsz) {
        onhandleCallback_ios({ cb: this.onhandleCallback });
      } else if (isAndroid && isYsz) {
        onHandleViewCallback_android({ cb: this.onhandleCallback });
      }
    },
    onhandleCallback(type, obj) {
      console.log(type, "type");
      if (type == "appAppWillAppearOrDisappear") {
        this.getFeedbackRoute();
      } else if (type == "onViewStatusChange") {
        this.getFeedbackRoute();
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/layout/components/buttom.vue